import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import ShuffledChoiceType from '../ShuffledChoiceType';
import messages from '../../../../../res/translations/messages';

const Battery1Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <ShuffledChoiceType choices={question.rows} />
        <h4><FormattedMessage {...messages.surveys.form.label.rows} /></h4>
        <ShuffledChoiceType choices={question.choices} />
    </>
);

Battery1Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default Battery1Type;
